import React, { useState } from 'react';
import { SketchPicker, ColorResult } from 'react-color';

interface ColorPickerProps {
  color: string;
  setColor: (color: string) => void;
  label: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ color, setColor, label }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => setDisplayColorPicker(!displayColorPicker);
  const handleClose = () => setDisplayColorPicker(false);
  const handleChangeComplete = (newColor: ColorResult) => setColor(newColor.hex);

  // Function to determine text color based on background color
  const getContrastingColor = (color: string) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000' : '#fff'; // Return black or white based on luminance
  };

  const textColor = getContrastingColor(color);

  return (
    <div className="flex flex-col items-center relative w-full mb-4">
            <label className="block text-[10px] text-right w-full text-gray-700">{label}</label>
      <div
        style={{
          backgroundColor: color,
          width: '100%',
          padding: '10px',
          borderRadius: '8px',
          cursor: 'pointer',
          border: '1px solid #d1d5db',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'border-color 0.3s',
        }}
        onClick={handleClick}
        onMouseEnter={e => (e.currentTarget.style.borderColor = '#a0aec0')} // hover effect
        onMouseLeave={e => (e.currentTarget.style.borderColor = '#d1d5db')}
      >
        <span style={{ color: textColor, fontWeight: 'bold' }}>{color}</span>
      </div>
      {displayColorPicker ? (
        <div style={{ position: 'absolute', zIndex: 2, top: '110%' }}>
          <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }} onClick={handleClose} />
          <SketchPicker color={color} onChangeComplete={handleChangeComplete} />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
